import CommonSettings from "./CommonSettings";
import PowerSettings from "./PowerSettings";
import MotorSettings from "./MotorSettings";
import CurtainSettings from "./CurtainSettings";
import VacuumSettings from "./VacuumSettings";
import SecuritySettings from "./SecuritySettings";
import EnergyMeterSettings from "./EnergyMeterSettings";
import EnergyMeterAlarms from "./EnergyMeterAlarms";
import { SETTINGS_PATHS } from "./paths";

export { SETTINGS_PATHS, settingsPathFor } from "./paths";

// The device settings pages. Each takes the device as location.state.data, e.g.
// history.push(settingsPathFor(device), { data: device }). For the router:
// {SETTINGS_ROUTES.map(({ path, component }) => <Route key={path} exact path={path} component={component} />)}
export const SETTINGS_ROUTES = [
  { path: SETTINGS_PATHS.COMMON, component: CommonSettings },
  { path: SETTINGS_PATHS.POWER, component: PowerSettings },
  { path: SETTINGS_PATHS.MOTOR, component: MotorSettings },
  { path: SETTINGS_PATHS.CURTAIN, component: CurtainSettings },
  { path: SETTINGS_PATHS.VACUUM, component: VacuumSettings },
  { path: SETTINGS_PATHS.SECURITY, component: SecuritySettings },
  { path: SETTINGS_PATHS.METER, component: EnergyMeterSettings },
  { path: SETTINGS_PATHS.METER_ALARMS, component: EnergyMeterAlarms },
];
